"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// DO NOT EDIT! This code is generated automatically.
exports.colors = {
    "lava_lighter__febebe": "#febebe",
    "lava_light__fe9392": "#fe9392",
    "lava__fe7877": "#fe7877",
    "lava_dark__e37c92": "#e37c92",
    "lava_darker__bf6e6e": "#bf6e6e",
    "tangerine_light__fda87e": "#fda87e",
    "tangerine__fd925e": "#fd925e",
    "tangerine_dark__dd8d7e": "#dd8d7e",
    "pumpkin_light__fdc133": "#fdc133",
    "pumpkin__fcb100": "#fcb100",
    "pumpkin_dark__ca9632": "#ca9632",
    "lemon_light__f9d94d": "#f9d94d",
    "lemon__f7d021": "#f7d021",
    "lemon_dark__ccb44c": "#ccb44c",
    "choco_light__c5a98d": "#c5a98d",
    "choco__b79470": "#b79470",
    "choco_dark__896f54": "#896f54",
    "lettuce_light__b2f561": "#b2f561",
    "lettuce__9ff23a": "#9ff23a",
    "lettuce_dark__8bd35f": "#8bd35f",
    "veggie_light__57d68d": "#57d68d",
    "veggie__2dcc70": "#2dcc70",
    "veggie_dark__2db182": "#2db182",
    "eco_light__88e14e": "#88e14e",
    "eco__6ad922": "#6ad922",
    "eco_dark__5cba47": "#5cba47",
    "mint_lighter__b8edbb": "#b8edbb",
    "mint_light__a0e7a5": "#a0e7a5",
    "mint__88e18e": "#88e18e",
    "mint_dark__88d29f": "#88d29f",
    "mint_darker__88c3af": "#88c3af",
    "aqua_light__77e0da": "#77e0da",
    "aqua__55d8d1": "#55d8d1",
    "aqua_dark__40a29d": "#40a29d",
    "ice_light__36ebf9": "#36ebf9",
    "ice__04e6f7": "#04e6f7",
    "ice_dark__03adb9": "#03adb9",
    "aquamarine_light__8dffe1": "#8dffe1",
    "aquamarine__70ffd9": "#70ffd9",
    "aquamarine_dark__54bfa3": "#54bfa3",
    "water_light__d5f3ff": "#d5f3ff",
    "water__99e1ff": "#99e1ff",
    "water_dark__99d6ff": "#99d6ff",
    "sky_light__77d7ff": "#77d7ff",
    "sky__55cdff": "#55cdff",
    "sky_dark__55bbff": "#55bbff",
    "denim_lighter__9fcbff": "#9fcbff",
    "denim_light__7fbaff": "#7fbaff",
    "denim__5fa9ff": "#5fa9ff",
    "denim_dark__477fbf": "#477fbf",
    "denim_darker__305580": "#305580",
    "eggplant_light__ceb1ff": "#ceb1ff",
    "eggplant__c29eff": "#c29eff",
    "eggplant_dark__9277bf": "#9277bf",
    "pink_light__fca0ff": "#fca0ff",
    "pink__fb88ff": "#fb88ff",
    "pink_dark__e48cff": "#e48cff",
    "peach_light__fdb8c5": "#fdb8c5",
    "peach__fc889f": "#fc889f",
    "peach_dark__e58cb2": "#e58cb2",
    "lychee_light__fda0b2": "#fda0b2",
    "lychee__fb6a87": "#fb6a87",
    "lychee_dark__de6f9e": "#de6f9e",
    "raven_light__616774": "#616774",
    "raven__394151": "#394151",
    "raven_dark__2b313d": "#2b313d",
    "slate_lighter__949aa7": "#949aa7",
    "slate_light__707889": "#707889",
    "slate__4c566c": "#4c566c",
    "slate_dark__394151": "#394151",
    "slate_darker__262b36": "#262b36",
    "charcoal_light__8d93a1": "#8d93a1",
    "charcoal__707889": "#707889",
    "charcoal_dark__545a67": "#545a67",
    "metal_lighter__b4bed5": "#b4bed5",
    "metal_light__9ba9c7": "#9ba9c7",
    "metal__8293b9": "#8293b9",
    "metal_dark__626e8b": "#626e8b",
    "metal_darker__414a5d": "#414a5d",
    "ash_light__c3cbdd": "#c3cbdd",
    "ash__b4bed5": "#b4bed5",
    "ash_dark__878fa0": "#878fa0",
    "lithium_light__e2e6ef": "#e2e6ef",
    "lithium__dbe0eb": "#dbe0eb",
    "lithium_dark__bbbee1": "#bbbee1",
    "mochi_lighter__f9fafd": "#f9fafd",
    "mochi_light__f7f9fd": "#f7f9fd",
    "mochi__f2f6fa": "#f2f6fa",
    "mochi_dark__ebedef": "#ebedef",
    "mochi_darker__e1e3ef": "#e1e3ef"
};
